import bananaIcon from '../../assets/icons/banana.png';
import santaBananaIcon from '../../assets/icons/santa-banana.png';
import coffeeIcon from '../../assets/icons/coffee.png';

export default function EmptyState({ onUploadIcon }) {
  const examples = [
    {
      title: "App Iconography",
      prompt: "Single colored icon (yellow) of the outline of a banana",
      color: "from-yellow-500/20 to-amber-500/20",
      image: bananaIcon
    },
    {
      title: "Smart Refinement",
      prompt: "Add a santa hat to my iOS banana icon for the holiday update",
      color: "from-red-500/20 to-rose-500/20",
      image: santaBananaIcon
    },
    {
      title: "Brand Iconography",
      prompt: "Cozy coffee shop icon, steam rising from cup, warm earth tones",
      color: "from-amber-500/20 to-orange-500/20",
      image: coffeeIcon
    }
  ];

  return (
    <div className="h-full flex flex-col items-center justify-center p-8 overflow-y-auto custom-scrollbar">
      <div className="text-center max-w-2xl mx-auto mb-12 animate-fade-in-up">
        <h3 className="text-4xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">
          Transform your ideas into icons.
        </h3>
        <p className="text-slate-500 dark:text-slate-400 text-lg font-medium leading-relaxed">
          Describe what you want to create, and we'll generate unique icon options for you.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-5xl mb-12">
        {examples.map((example, index) => (
          <div
            key={index}
            className="group relative glass dark:bg-white/[0.03] p-6 transition-all hover:scale-[1.05] hover:border-violet-500/40 hover:shadow-2xl hover:shadow-violet-500/10 animate-fade-in-up"
            style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'both' }}
          >
            <div className={`w-full aspect-square rounded-2xl bg-gradient-to-br ${example.color} flex items-center justify-center mb-6 border border-white/10 shadow-inner overflow-hidden`}>
              <div className="w-full h-full transform transition-transform group-hover:scale-110 duration-500 flex items-center justify-center p-8">
                <img
                  src={example.image}
                  alt={example.title}
                  className="w-full h-full object-contain drop-shadow-2xl brightness-110"
                />
              </div>
            </div>

            <div className="space-y-3">
              <h4 className="font-black text-slate-900 dark:text-white flex items-center gap-2 text-sm tracking-tight">
                {example.title}
              </h4>
              <div className="bg-slate-900/5 dark:bg-white/5 rounded-xl p-4 text-xs text-slate-500 dark:text-slate-400 font-bold leading-relaxed border border-white/5 italic">
                "{example.prompt}"
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.2em] animate-pulse">
        Scroll to explore more possibilities
      </div>
    </div>
  );
}


